import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import NotFound from '../component/features/home/NotFound';
import Applayout from '../component/layouts/Applayout';
import Signin from '../component/no-auth/signin/SignIn';

import { isAuthenticated, isAuthorized } from '../shared/settings/auth';
import SignUp from '../component/no-auth/signin/SignUp';
import SetPassword from '../component/no-auth/set-password/SetPassword';
import ForgotPassword from '../component/no-auth/signin/ForgotPassword';
import LandingPage from '../component/features/home/LandingPage';
import UserAgreement from '../component/features/home/UserAgreement';
export class FeaturesRouter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            load: false
        }
    }

    componentDidMount() {
        isAuthenticated().then(() => {
            this.setState({
                load: true
            })
        })
    }

    render() {
        return (
            this.state.load ?
                <Switch>
                    <Route exact path="/not-found" component={NotFound} />
                    <Route exact path="/">
                        <LandingPage {...this.props} />
                    </Route>
                    <Route exact path="/sign-in">
                        {
                            isAuthorized() ? <Redirect to="/home" /> : <Signin {...this.props} />
                        }
                    </Route>
                    <Route exact path="/forgot-password">
                        {
                            isAuthorized() ? <Redirect to="/home" /> : <ForgotPassword {...this.props} />
                        }
                    </Route>
                    <Route exact path="/sign-up">
                        {
                            isAuthorized() ? <Redirect to="/home" /> : <SignUp {...this.props} />
                        }
                    </Route>
                    <Route exact path="/set-password">
                        <SetPassword {...this.props} />
                    </Route>
                    <Route exact path="/user-agreement" component={UserAgreement} />
                    <Route>
                        {
                            isAuthorized() ? <Applayout {...this.props} /> : <Redirect to="/" />
                        }
                    </Route>
                    <Redirect to="/not-found" />
                </Switch> : <></>
        );
    }
}